import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, NavParams } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { KlmrTakeTemplatePage } from '../klmr-take-template/klmr-take-template';
import { SearchPage } from '../search/search';
import { SelectCategoryPage } from '../select-category/select-category';
import { SelectRatingPage } from '../select-rating/select-rating';
@IonicPage()
@Component({
  selector: 'page-klmr-take-template-add',
  templateUrl: 'klmr-take-template-add.html',
})
export class KlmrTakeTemplateAddPage {
  isUpdate: boolean = false;
  actionAllowed: boolean = true;
  disabled: boolean = true;
  params: any = {};
  questions_alphabet: any = [];
  questions_numeric: any = [];
  category: any = [];
  templateList: any = [];
  templateId: any = null;
  jobcardId: any = null;
  jobcardList: any = [];
  questionList: any = [];
  rejectedList: any = [];
  methodName: any = null;
  selectedQuestion: any = null;
  selectedQuestionSet: any = {};
  hazard: any = null;
  reduceRisk: any = null;

  parentIndex: any = -1;
  childIndex: any = -1;

  selectedHazard: any = null;
  selectedReduceRisk: any = null;


  selectedHazardRating: any = null;
  selectedReduceRiskRating: any = null;


  riskLeveList: any = [];


  selectedTemplate: any = "Select Template";
  selectedJobcard: any = "Select Jobcard";
  taskName: any = "";
  selectedData: any = {};
  currentGroup:any = null;
  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider, private modalController: ModalController) {
    
    this.params = this.navParams.get('param');
    this.disabled = this.navParams.get('disabled');
    this.getClassName();
    console.log(this.disabled)
    if (this.params) {
      this.isUpdate = true;

    }
  }

  async getClassName(){
  this.currentGroup = await this.utiltiy.getStorage("currentClass");

  }

  ionViewDidLoad() {
    this.getMetaData();
  }

  fullReset() {
    this.isUpdate = false;
    this.actionAllowed = true;
    this.disabled = true;
    this.params = {};
    this.questions_alphabet = [];
    this.questions_numeric = [];
    this.category = [];
    this.templateList = [];
    this.templateId = null;
    this.jobcardId = null;
    this.jobcardList = [];
    this.questionList = [];
    this.rejectedList = [];
    this.methodName = null;
    this.selectedQuestion = null;
    this.selectedQuestionSet = {};
    this.hazard = null;
    this.reduceRisk = null;

    this.parentIndex = -1;
    this.childIndex = -1;

    this.selectedHazard = null;
    this.selectedReduceRisk = null;


    this.selectedHazardRating = null;
    this.selectedReduceRiskRating = null;


    this.riskLeveList = [];


    this.selectedTemplate = "Select Template";
    this.selectedJobcard = "Select Jobcard";
    this.taskName = "";
    this.selectedData = {};
    this.getMetaData();
  }

  reset() {
    this.parentIndex = -1;
    this.childIndex = -1;
    this.selectedHazard = null;
    this.selectedReduceRisk = null;
    this.selectedHazardRating = null;
    this.selectedReduceRiskRating = null;
    this.hazard = null;
    this.reduceRisk = null;
  }

  async getMetaData() {
    this.utiltiy.startLoading();
    let questionList = await this.getData("take_5_questions_list");
    let jobcardList = await this.getData("get_jobcard_no_for_template");
    let templateList = await this.getData("search_template_list");
    this.jobcardList = jobcardList;
    this.questionList = templateList;
    console.log("jobcardList", jobcardList);
    console.log("templateList", templateList);
    this.generateData(questionList)

    this.utiltiy.stopLoading();
  }

  async generateData(templateList) {
    let questions_alphabet_list = [];
    let questions_numeric_list = [];
    let category_list = [];

    templateList.questions_alphabet.forEach(element => {
      element.take_5_answer = null;
      let obj = {
        "id": element.id,
        "value": null,
        "question": element.take_5_questions,
        "type": 1,
        "payload": element
      }
      questions_alphabet_list.push(obj);
    });

    templateList.questions_numeric.forEach(element => {
      element.take_5_answer = null;
      let obj = {
        "id": element.id,
        "value": null,
        "question": element.take_5_questions,
        "type": 3,
        "payload": element
      }
      questions_numeric_list.push(obj);
    });

    let keys = Object.keys(templateList);


    keys.forEach(element => {
      if (element != "ppe_category" && element != "questions_alphabet" && element != "questions_numeric") {
        let key = templateList[element];
        let options = [];
        key.forEach(element_ => {

          let optionObj = {
            "id": element_.id,
            "value": false,
            "question": element_.take_5_ppe_itm,
            "type": 2,
            "optionPayload": element_
          }
          options.push(optionObj);
        });
        let obj = {
          "id": element,
          "value": null,
          "question": element,
          "option": options,
        }
        category_list.push(obj);
      }

    });

    category_list.forEach(element => {
      let index = templateList.ppe_category.findIndex(list_ => list_['take_5_ppe_category'] == element.question);
      if (index != -1) {
        element.id = templateList.ppe_category[index].id;
        element.payload = templateList.ppe_category[index];
      }
    });

    // ppe_category

    console.log("category_list-01", category_list)

    if (this.isUpdate) {
      // this.mergeData(questions_alphabet_list,questions_numeric_list,category_list);
    } else {
      questions_alphabet_list =  questions_alphabet_list.sort((a, b) => parseFloat(a.payload.take_5_question_order) - parseFloat(b.payload.take_5_question_order));
      questions_numeric_list =  questions_numeric_list.sort((a, b) => parseFloat(a.payload.take_5_question_order) - parseFloat(b.payload.take_5_question_order));
      console.log("questions_numeric_list",questions_numeric_list)
      this.category = category_list;
      this.questions_alphabet = questions_alphabet_list;
      this.questions_numeric = questions_numeric_list;
      this.generateTemplate();
      console.log("===", this.templateList)
    }
  }

  generateTemplate() {
    this.templateList = [
      {
        "name": "STEP:1 STOP AND THINK THROUGH THE TASK",
        "children": this.questions_alphabet,
        "showButton": false,
        "hideCategory": false
      },
      {
        "name": "STEP:2 PPE USED",
        "children": this.category,
        "showButton": true,
        "questionSet": false,
        "hideCategory": false
      },
      {
        "name": "STEP:3 IDENTIFY THE HAZARDS",
        "children": this.questions_numeric,
        "showButton": false,
        "hideCategory": false
      },
      {
        "name": "STEP:4 ASSESS RISKS, MANAGE HAZARDS",
        "children": [],
        "showButton": true,
        "questionSet": true,
        "hideCategory": false
      },
      {
        "name": "STEP:5 PROCEED AND MONITOR",
        "children": [],
        "showButton": true,
        "questionSet": true,
        "hideCategory": false
      }
    ]
  }

  templatetoggleSection(i) {
    this.templateList[i].open = !this.templateList[i].open;
  }

  templatetoggleItem(i, j) {
    this.templateList[i].children[j].open = !this.templateList[i].children[j].open;
  }

  onSelected(i, j) {
    console.log("this.templateList[i].children[j]", this.templateList[i].children[j])
    this.selectedQuestionSet = this.templateList[i].children[j];
    this.parentIndex = i;
    this.childIndex = j;
    this.templateList[i].children[j].categories = [];
    // this.templateList[i+1].children[j].selected = true
    this.selectedQuestion = this.templateList[i].children[j].question;

  }

  recreateList() {

  }

  getIndexValue(i, j) {
    let alphabet = "abcdefghijklmnopqrstuvwxyz";
return null;
    // if (i == 0) {
    //   return alphabet[j].toUpperCase();
    // } else if (i == 2) {
    //   return j + 1;
    // }

  }

  negativeAnswer(row) {
    console.log("this.selectedData,", this.selectedData)
    console.log("row is", row)

    // if(this.templateId && row.type == 3){
    //   this.prefilledData(row);
    //   return;
    // }
    console.log("+++++++++++++++++++++++++++++++++++++++")
    if (row.type == 3 && row.value) {
      let value = row.value;
      let expectedAnswer = row.payload.take_5_question_hazard_status == "true" ? "yes" : row.payload.take_5_question_hazard_status == "false" ? "no" : "non";
      console.log("value", value);
      console.log("expectedAnswer", expectedAnswer);
      if (value == "non") {
        this.removeList(row.id);
        return;
      }

      if (value != expectedAnswer) {
        // row.selected = false;
        // this.rejectedList.push(row);
        // this.assignToTemplate();
        this.addList(row);
      } else {
        this.removeList(row.id);
      }

      // row.selected = false;
      // this.rejectedList.push(row);
      // this.assignToTemplate();
    }

    // if(row.type == 3 && row.value != "no"){
    //   console.log("---",row)
    //   let index = this.rejectedList.findIndex(list_ => list_['id'] == row.id);
    //   if(index != -1){
    //     this.rejectedList.splice(index, 1);
    //     console.log("-1--", this.rejectedList)
    //     this.assignToTemplate();
    //   }
    //   // row.selected = false;
    // }
    console.log("row is", this.rejectedList)
  }

  async removeList(id) {
    let index = this.rejectedList.findIndex(list_ => list_['id'] == id);
    if (index != -1) {
      this.rejectedList.splice(index, 1);
      console.log("-1--", this.rejectedList)
      this.assignToTemplate();
    }
  }

  async addList(row) {
    let index = this.rejectedList.findIndex(list_ => list_['id'] == row.id);
    if (index == -1) {
      row.selected = false;
      this.rejectedList.push(row);
      this.assignToTemplate();
    }
  }

  async prefilledData(row) {
    console.log("final row", row)
    let questions = JSON.parse(this.selectedData.take_5_template_questions);
    let key = parseFloat(row.id);
    let value = questions[key]
    console.log("questions", questions)
    console.log("key", key)
    console.log("value", value)
    if (value) {
      console.log("--1---")


      if (row.value != "non") {
        console.log("--2---")
        if (value != row.value) {
          console.log("--3---")
          row.selected = false;
          this.rejectedList.push(row);
          this.assignToTemplate();
        } else {
          console.log("--4---")
          let index = this.rejectedList.findIndex(list_ => list_['id'] == row.id);
          console.log("--5---", index)
          if (index != -1) {
            console.log("--6---")
            this.rejectedList.splice(index, 1);
            console.log("-1--", this.rejectedList)
            this.assignToTemplate();
          }
        }
      }
    }
  }

  assignToTemplate() {
    this.templateList[3].children = this.rejectedList;
    this.templateList[4].children = this.templateList[3].children;
  }

  async createData(list, key, value) {
    list.forEach(element => {
      element.key = element[key];
      element.value = element[value];
    });

    return list;
  }

  async openModal(list, title, key, value, model) {

    // if(this.isDisabled){
    //   return;
    // }

    console.log("list", list)
    list = await this.createData(list, key, value);
    const profileModal = this.modalController.create(SearchPage, { data: { list: list, header: title } }, { cssClass: 'managers', enableBackdropDismiss: true });
    profileModal.onDidDismiss(async (data: any) => {
      console.log(value, "value", data);
      if (data) {
        let id = data.key;
        this[model] = data.value;
        if (model == 'selectedTemplate') {
          this.templateId = id;
          let data = await this.getTemplateData(id);
          this.selectedData = data[0];
          this.mergeData(this.questions_alphabet, this.questions_numeric, this.category);
          console.log("data", data)
        } else {
          this.jobcardId = data.key;
        }
      }
    });
    profileModal.present();
  }


  categoryPopup(row, i, j) {
    console.log("this.templateList[i].children[j]", this.templateList[i].children[j])
    const profileModal = this.modalController.create(SelectCategoryPage, { data: row }, { cssClass: 'category-popup', enableBackdropDismiss: true, });
    profileModal.onDidDismiss(data => {
      console.log("data", data)
      if (data) {
        this.templateList[i].children[j].option = data.option

      }
    });
    profileModal.present();
  }


  ratingPopup(type) {
    // if(!this.templateId){
    //   this.utiltiy.toaster("Select Teemplate");
    //   return;
    // }

    if (this.parentIndex == -1 && this.childIndex == -1) {
      this.utiltiy.toaster("Select Question");
      return;
    }

    if (type == "1" && !this.hazard) {
      this.utiltiy.toaster("Enter Detail");
      return;
    }

    if (type == "2" && !this.reduceRisk) {
      this.utiltiy.toaster("Enter Detail");
      return;
    }

    let obj = {
      "type": type
    }
    const profileModal = this.modalController.create(SelectRatingPage, { data: obj }, { enableBackdropDismiss: true, });
    profileModal.onDidDismiss(data => {
      console.log("data", data)
      console.log("=====", this.templateList[this.parentIndex].children[this.childIndex])
      if (data) {
        if (data.type == "1") {
          let payload = {
            "comment": this.hazard,
            "rating": data.Take_5_Risk_Matrix_Rating,
            "types": type,
            "code": data.colourCode
          }
          this.selectedHazard = data.colourCode;
          this.selectedHazardRating = data.Take_5_Risk_Matrix_Rating;

          this.templateList[this.parentIndex].children[this.childIndex].categories.push(payload);
        } else if (data.type == "2") {
          let payload = {
            "comment": this.reduceRisk,
            "rating": data.Take_5_Risk_Matrix_Rating,
            "types": type,
            "code": data.colourCode
          }
          this.selectedReduceRisk = data.colourCode;
          this.selectedReduceRiskRating = data.Take_5_Risk_Matrix_Rating;
          this.templateList[this.parentIndex].children[this.childIndex].categories.push(payload);
        }

        if (this.templateList[this.parentIndex].children[this.childIndex].categories.length > 1) {
          this.templateList[this.parentIndex].children[this.childIndex].selected = true;
          console.log("--", this.templateList[this.parentIndex].children[this.childIndex])
          // this.reset();
        }

      }
    });
    profileModal.present();
  }

  saveHazard() {
    console.log("--", this.templateList[this.parentIndex].children[this.childIndex])
    let data = this.templateList[this.parentIndex].children[this.childIndex].categories;
    let obj = {
      "TakeFive_RiskAssessment_Hazard_Description": data[0].comment,
      "TakeFive_RiskAssessment_Risk_Rating": data[0].rating,
      "riskColour": data[0].code,
      "TakeFive_RiskAssessment_Controls_Description": data[1].comment,
      "TakeFive_RiskAssessment_Residual_Rating": data[1].rating,
      "residualColour": data[1].code,
      "Questions_id": this.templateList[this.parentIndex].children[this.childIndex].id,
    }
    this.riskLeveList.push(obj);
    this.reset();
  }

  saveRisk(mobileId) {

    let formData: FormData = new FormData();

    formData.append("method_name", "save_risk_assessment");
    formData.append("Mobile_Form_id", mobileId);
    this.riskLeveList.forEach(element => {
      formData.append("Questions_id[]", element.Questions_id);
      formData.append("TakeFive_RiskAssessment_Hazard_Description[]", element.TakeFive_RiskAssessment_Hazard_Description);
      formData.append("TakeFive_RiskAssessment_Risk_Rating[]", element.TakeFive_RiskAssessment_Risk_Rating);
      formData.append("TakeFive_RiskAssessment_Controls_Description[]", element.TakeFive_RiskAssessment_Controls_Description);
      formData.append("TakeFive_RiskAssessment_Residual_Rating[]", element.TakeFive_RiskAssessment_Residual_Rating);
    });
    let apiUrl =  this.currentGroup == 'klmr'?'/prestart/take_5/Add_Templates':'/tansix_prestart/take_5/Add_Templates';
    this.api.post(apiUrl, false, formData)
      .then((result: any) => {
        console.log("result", result)
        if (result.status) {
          this.fullReset();
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      })

  }




  async mergeData(questions_alphabet_list, questions_numeric_list, category_list) {
    // this.methodName = this.params.take_5_template_task;
    let take_5_template_ppe = JSON.parse(this.selectedData.take_5_template_ppe);
    let take_5_template_questions = JSON.parse(this.selectedData.take_5_template_questions);

    let keys = Object.keys(take_5_template_questions);
    keys.forEach(element => {
      let i = questions_alphabet_list.findIndex(list_ => list_['id'] == element);
      if (i != -1) {
        questions_alphabet_list[i].value = take_5_template_questions[element];
      }

      let j = questions_numeric_list.findIndex(list_ => list_['id'] == element);
      if (j != -1) {
        questions_numeric_list[j].value = take_5_template_questions[element];
      }

    });

    let Categorykeys = Object.keys(take_5_template_ppe);

    Categorykeys.forEach(element => {
      let i = category_list.findIndex(list_ => list_['id'] == element);
      if (i != -1) {
        let optionKeys = Object.keys(take_5_template_ppe[element]);
        optionKeys.forEach(element_ => {
          let j = category_list[i].option.findIndex(list_ => list_['id'] == element_);
          if (j != -1) {
            category_list[i].option[j].value = true;
          }

        });

      }
    });
    this.category = category_list;
    this.questions_alphabet = questions_alphabet_list;
    this.questions_numeric = questions_numeric_list;
    this.generateTemplate();

  }

  async getData(method) {
    let formData: FormData = new FormData();

    formData.append("method_name", method);
    let apiUrl =  this.currentGroup == 'klmr'?'/prestart/take_5/Add_Templates':'/tansix_prestart/take_5/Add_Templates';
    return this.api.post(apiUrl, false, formData)
      .then((result: any) => {
        console.log("result", result)
        if (result.status) {
          return result.result;
        } else {
          return [];
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      })

  }

  async getTemplateData(id) {
    let formData: FormData = new FormData();

    formData.append("method_name", 'get_template_list_admin');
    formData.append("template_id", id);
    let apiUrl =  this.currentGroup == 'klmr'?'/prestart/take_5/Add_Templates':'/tansix_prestart/take_5/Add_Templates';

    return this.api.post(apiUrl, false, formData)
      .then((result: any) => {
        console.log("result", result)
        if (result.status) {
          return result.result;
        } else {
          return [];
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      })

  }

  submit() {
    if (!this.methodName) {
      this.utiltiy.toaster("Task Name Required");
      return
    }
    let formData: FormData = new FormData();
    // console.log("this.questions_alphabet",this.questions_alphabet);
    // console.log("this.this.questions_numeric",this.questions_numeric);
    // console.log("this.category",this.category);
    let obj = [];
    let categoryObj = [];
    this.questions_alphabet.forEach(element => {
      if (element.value) {
        // let key = element.id
        let value = element.value
        element.payload.take_5_answer = value;

        obj.push(element.payload)
      }
    });

    this.questions_numeric.forEach(element => {
      if (element.value) {
        // let key = element.id
        let value = element.value
        element.payload.take_5_answer = value;

        obj.push(element.payload)
      }
    });

    console.log("obj", obj)

    this.category.forEach(element => {
      let obj: any = {};
      let insideObj = []
      obj = element.payload;
      obj.items = [];
      element.option.forEach(element_ => {
        if (element_.value) {
          // let key = element_.id
          // let value = element_.question
          // insideObj[key] = value;
          element_.optionPayload.take_5_ppe_category = element.payload.take_5_ppe_category;
          element_.optionPayload.ppe_category_order = element.payload.ppe_category_order;
          insideObj.push(element_.optionPayload)
          // formData.append("take_5_template_ppe[]",element_.question);
        }
      });
      if (insideObj.length != 0) {
        obj.items = insideObj;
        categoryObj.push(obj)
      }
      // if(Object.keys(insideObj).length === 0){
      //   delete categoryObj[element.id];
      // }else{
      //   categoryObj[element.id] = insideObj
      // }
    });
    console.log("categoryObj", categoryObj)
    // return 
    formData.append("take_5_template_task", this.methodName);
    // if(this.templateId){
    formData.append("Take_5_Template_Id", this.templateId ? this.templateId : "");
    formData.append("Take_5_JobcardNo_Id", this.jobcardId ? this.jobcardId : "");
    // formData.append("Take_5_RiskAssessment_Id","");
    formData.append("take_5_template_questions", JSON.stringify(obj));
    formData.append("take_5_template_ppe", JSON.stringify(categoryObj));
    if (this.isUpdate) {
      formData.append("id", this.params.id);
      formData.append("method_name", "update_template");

    } else {
      formData.append("method_name", "add_template");
    }

    console.log("obj", obj)
    console.log("formData", formData);
    this.utiltiy.startLoading();
    this.addTemplate(formData);
  }

  addTemplate(formData) {
    let apiUrl =  this.currentGroup == 'klmr'?'/prestart/take_5/Add_Templates':'/tansix_prestart/take_5/Add_Templates';
    this.api.post(apiUrl, false, formData)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          if (this.riskLeveList.length > 0) {
            this.saveRisk(result.Mobile_Form_id);
          } else {
            this.fullReset();
          }
          // location.reload();
          // this.navCtrl.setRoot(KlmrTakeTemplatePage);
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }

}



// WEBPACK FOOTER //
// ./src/pages/klmr-take-template-add/klmr-take-template-add.ts